export default "__VITE_ASSET__DgMr0zEQ__"